import { render } from "./iconGlobe.vue?vue&type=template&id=3d89a260"
import script from "./iconGlobe.vue?vue&type=script&lang=js"
export * from "./iconGlobe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__